import { createContext, useContext } from 'react';

import { resolveMount, type Mount } from './resolve-mount';

// The mount the current request arrived on, for renders that cannot read
// `window.location` — i.e. SSR. Resolved once in `pages/_app.tsx`'s
// getInitialProps, which is the only place that can see the original URL: Pepyaka
// strips the mount prefix before the pod, so only the forwarded-URL header still
// carries it.
//
// The default is the same `/orion-web` that `resolveMount` itself falls back to for
// an unrecognised host, so a subtree rendered with no provider behaves as before.
export const MountContext = createContext<Mount>('/orion-web');

// The app is mounted at three parallel places: `/orion-web` and `/symphony-web` (manage.wix.com),
// and '' (root, on symphony.wix.com).
// The base path is just the mount prefix — pages live directly under it, so the
// root mount's base path is the empty string.
//
// Reads window.location synchronously rather than going through React state: a
// state-backed value defaults until its effect runs post-mount, so on the very
// first render any page using it would return an /orion-web basePath even though
// the URL is /symphony-web/... .
export function useBasePath(): string {
  const ssrMount = useContext(MountContext);
  if (typeof window !== 'undefined') {
    return resolveMount(window.location.pathname);
  }
  return ssrMount;
}
